"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.startTask = void 0;
const k = require("kleur");
const stripAnsi = require("strip-ansi");
const spin_1 = require("./spin");
const _1 = require(".");
let activeTasks = new Set();
function startTask(text) {
    let start = Date.now();
    let output = '';
    const task = {
        get height() {
            const lines = stripAnsi(output).split('\n');
            return lines.reduce((height, line) => height + Math.ceil(line.length / process.stdout.columns), 0);
        },
        render(showElapsed = true) {
            const elapsed = showElapsed ? k.gray(_1.formatElapsed(start)) : '';
            output = spin_1.getSpinner() + ` ${text} ` + elapsed;
            _1.print(output + '\n');
        },
        update(msg) {
            text = msg;
            if (!_1.isInteractive) {
                this.render();
            }
        },
        finish(msg) {
            printTasks();
            if (msg) {
                const color = msg.endsWith(' in') ? k.white : k.gray;
                _1.success(msg + color(' ' + _1.formatElapsed(start)));
            }
            activeTasks.delete(this);
            if (!activeTasks.size) {
                spin_1.spinListeners.delete(printTasks);
                spin_1.spin(false);
            }
        },
    };
    if (!activeTasks.size) {
        spin_1.spinListeners.add(printTasks);
        spin_1.spin(true);
    }
    install();
    if (!wiped) {
        task.render(false);
    }
    activeTasks.add(task);
    return task;
}
exports.startTask = startTask;
let wiped = false;
function printTasks() {
    if (!wiped && activeTasks.size) {
        wiped = true;
        _1.clear(getTasksHeight());
        process.nextTick(() => {
            activeTasks.forEach(task => task.render());
            wiped = false;
        });
    }
}
function getTasksHeight() {
    let height = 0;
    activeTasks.forEach(task => (height += task.height));
    return height;
}
let installed = false;
function install() {
    if (!_1.isInteractive)
        return;
    if (!installed) {
        installed = true;
        for (const name of ['stdout', 'stderr'])
            hookBefore(process[name], 'write', printTasks);
        for (const name of ['log', 'warn', 'error'])
            hookBefore(console, name, printTasks);
    }
}
function hookBefore(target, method, hook) {
    const impl = target[method];
    target[method] = (...args) => (hook(args), impl.apply(target, args));
}
//# sourceMappingURL=task.js.map